var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('assign-rent-plan',{ref:"changeRentPlanModal",attrs:{"items":_vm.items,"is-value-tiered":false},on:{"selected":function($event){return _vm.updateChangedPlan($event)},"close":function($event){return _vm.$emit('input', false)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }